import { Task } from '@/shared/types/task';
import { useResultRequiredModalStore } from '@/entities/task/model/stores/result-required-modal';
import { useTaskSelectionModalStore } from '@/entities/task/model/stores/task-selection-modal';

export function taskRequiresApproval(task?: Task | null): boolean {
  const v = (task as ANY)?.requiresApproval;
  return v === 'Y' || v === true;
}

export function taskHasResult(task?: Task | null): boolean {
  return !!(task as ANY)?.hasResult;
}

type CompleteTaskFn = (taskId: string) => Promise<void>;

type CompleteTaskWithGuardsArgs = {
  taskId: string;
  task?: Task | null;
  completeTask: CompleteTaskFn;
  beforeOpenModal?: () => void;
};

export async function completeTaskWithGuards({
  taskId,
  task,
  completeTask,
  beforeOpenModal,
}: CompleteTaskWithGuardsArgs) {
  // Завершать задачу без результата нельзя: если результат не указан — сначала
  // открываем модалку «укажите результат», и уже после его сохранения завершаем
  // задачу и открываем модалку завершения (см. afterSaveAction ниже). task === null
  // означает, что подробности задачи не удалось получить (ошибка сети) — в этом
  // случае не блокируем завершение из-за неопределённости.
  if (task && !taskHasResult(task)) {
    const s = useResultRequiredModalStore.getState();

    s.open({ taskId, title: (task as ANY)?.title });

    s.setAfterSaveAction(async () => {
      await completeTask(taskId);
      beforeOpenModal?.();
      useTaskSelectionModalStore
        .getState()
        .openModal({ mode: 'complete', taskId });
    });

    return;
  }

  await completeTask(taskId);
  beforeOpenModal?.();
  useTaskSelectionModalStore.getState().openModal({ mode: 'complete', taskId });
}
